let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kPIBO")).then(() => parcelRequire('4fxpw'));